// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file cos/workbatch.proto (package lvdr.v2.cos, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file cos/workbatch.proto.
 */
export const file_cos_workbatch: GenFile = /*@__PURE__*/
  fileDesc("ChNjb3Mvd29ya2JhdGNoLnByb3RvEgtsdmRyLnYyLmNvcyIuChZMaXN0V29ya0JhdGNoZXNSZXF1ZXN0EhQKDHdvcmtzcGFjZV9pZBgBIAEoCSLJAQoXTGlzdFdvcmtCYXRjaGVzUmVzcG9uc2USJwoHYmF0Y2hlcxgBIAMoCzIWLmx2ZHIudjIuY29zLldvcmtCYXRjaBIQCghkZWdyYWRlZBgCIAMoCRIsCglwcm9wb3NhbHMYAyADKAsyGS5sdmRyLnYyLmNvcy5Xb3JrUHJvcG9zYWwSFgoOdW5kb19hdmFpbGFibGUYBCABKAgSEQoJbW92ZWRfb3V0GAUgAygJEhoKEnVuZG9fZXhwaXJlc19hdF9tcxgGIAEoAyJdCglXb3JrQmF0Y2gSCgoCaWQYASABKAkSEAoIdGVtcGxhdGUYAiABKAkSDAoEbmFtZRgDIAEoCRIQCgh0YXNrX2lkcxgEIAMoCRISCgpzcGxpdF9wYXJ0GAUgASgIIksKDFdvcmtQcm9wb3NhbBIKCgJpZBgBIAEoCRINCgVsYWJlbBgCIAEoCRIOCgZyZWFzb24YAyABKAkSEAoIdGFza19pZHMYBCADKAkiVAoOV29ya0JhdGNoU3BsaXQSEAoIYmF0Y2hfaWQYASABKAkSMAoGZ3JvdXBzGAIgAygLMiAubHZkci52Mi5jb3MuV29ya0JhdGNoU3BsaXRHcm91cCInChNXb3JrQmF0Y2hTcGxpdEdyb3VwEhAKCHRhc2tfaWRzGAEgAygJIuYBCh9VcGRhdGVXb3JrQmF0Y2hPdmVycmlkZXNSZXF1ZXN0EhQKDHdvcmtzcGFjZV9pZBgBIAEoCRIQCghtb3ZlX291dBgCIAMoCRISCgpjbGVhcl9pdGVtGAMgAygJEioKBXNwbGl0GAQgASgLMhsubHZkci52Mi5jb3MuV29ya0JhdGNoU3BsaXQSDAoEdW5kbxgFIAEoCBIaChJhY2NlcHRfcHJvcG9zYWxfaWQYBiABKAkSFAoMYWNjZXB0X2xhYmVsGAcgASgJEhsKE2Rpc21pc3NfcHJvcG9zYWxfaWQYCCABKAkiVwogVXBkYXRlV29ya0JhdGNoT3ZlcnJpZGVzUmVzcG9uc2USMwoFc3RhdGUYASABKAsyJC5sdmRyLnYyLmNvcy5MaXN0V29ya0JhdGNoZXNSZXNwb25zZUIkWiJnaXRodWIuY29tL2d2czQyL2x2ZHIvcHJvdG8vdjIvY29zYgZwcm90bzM");

/**
 * @generated from message lvdr.v2.cos.ListWorkBatchesRequest
 */
export type ListWorkBatchesRequest = Message<"lvdr.v2.cos.ListWorkBatchesRequest"> & {
  /**
   * "" = Private
   *
   * @generated from field: string workspace_id = 1;
   */
  workspaceId: string;
};

/**
 * Describes the message lvdr.v2.cos.ListWorkBatchesRequest.
 * Use `create(ListWorkBatchesRequestSchema)` to create a new message.
 */
export const ListWorkBatchesRequestSchema: GenMessage<ListWorkBatchesRequest> = /*@__PURE__*/
  messageDesc(file_cos_workbatch, 0);

/**
 * @generated from message lvdr.v2.cos.ListWorkBatchesResponse
 */
export type ListWorkBatchesResponse = Message<"lvdr.v2.cos.ListWorkBatchesResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.cos.WorkBatch batches = 1;
   */
  batches: WorkBatch[];

  /**
   * signal kinds not known: "thread" | "client" | "action"
   *
   * @generated from field: repeated string degraded = 2;
   */
  degraded: string[];

  /**
   * pending only; always empty for a space
   *
   * @generated from field: repeated lvdr.v2.cos.WorkProposal proposals = 3;
   */
  proposals: WorkProposal[];

  /**
   * @generated from field: bool undo_available = 4;
   */
  undoAvailable: boolean;

  /**
   * open task ids the user moved out in this store (for Put back)
   *
   * @generated from field: repeated string moved_out = 5;
   */
  movedOut: string[];

  /**
   * unix ms when the undo snapshot expires; 0 = no undo
   *
   * @generated from field: int64 undo_expires_at_ms = 6;
   */
  undoExpiresAtMs: bigint;
};

/**
 * Describes the message lvdr.v2.cos.ListWorkBatchesResponse.
 * Use `create(ListWorkBatchesResponseSchema)` to create a new message.
 */
export const ListWorkBatchesResponseSchema: GenMessage<ListWorkBatchesResponse> = /*@__PURE__*/
  messageDesc(file_cos_workbatch, 1);

/**
 * @generated from message lvdr.v2.cos.WorkBatch
 */
export type WorkBatch = Message<"lvdr.v2.cos.WorkBatch"> & {
  /**
   * "wb_" + 32 hex; a sub-batch is "<parent>-<n>"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * user | thread | series | client | client_replies | tag | replies | action
   *
   * @generated from field: string template = 2;
   */
  template: string;

  /**
   * contact name, series title, tag, group label or action kind; "" when not known
   *
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: repeated string task_ids = 4;
   */
  taskIds: string[];

  /**
   * true for a sub-batch "<parent>-<n>"; the server refuses to split it
   *
   * @generated from field: bool split_part = 5;
   */
  splitPart: boolean;
};

/**
 * Describes the message lvdr.v2.cos.WorkBatch.
 * Use `create(WorkBatchSchema)` to create a new message.
 */
export const WorkBatchSchema: GenMessage<WorkBatch> = /*@__PURE__*/
  messageDesc(file_cos_workbatch, 2);

/**
 * @generated from message lvdr.v2.cos.WorkProposal
 */
export type WorkProposal = Message<"lvdr.v2.cos.WorkProposal"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * @generated from field: string reason = 3;
   */
  reason: string;

  /**
   * @generated from field: repeated string task_ids = 4;
   */
  taskIds: string[];
};

/**
 * Describes the message lvdr.v2.cos.WorkProposal.
 * Use `create(WorkProposalSchema)` to create a new message.
 */
export const WorkProposalSchema: GenMessage<WorkProposal> = /*@__PURE__*/
  messageDesc(file_cos_workbatch, 3);

/**
 * @generated from message lvdr.v2.cos.WorkBatchSplit
 */
export type WorkBatchSplit = Message<"lvdr.v2.cos.WorkBatchSplit"> & {
  /**
   * @generated from field: string batch_id = 1;
   */
  batchId: string;

  /**
   * @generated from field: repeated lvdr.v2.cos.WorkBatchSplitGroup groups = 2;
   */
  groups: WorkBatchSplitGroup[];
};

/**
 * Describes the message lvdr.v2.cos.WorkBatchSplit.
 * Use `create(WorkBatchSplitSchema)` to create a new message.
 */
export const WorkBatchSplitSchema: GenMessage<WorkBatchSplit> = /*@__PURE__*/
  messageDesc(file_cos_workbatch, 4);

/**
 * @generated from message lvdr.v2.cos.WorkBatchSplitGroup
 */
export type WorkBatchSplitGroup = Message<"lvdr.v2.cos.WorkBatchSplitGroup"> & {
  /**
   * @generated from field: repeated string task_ids = 1;
   */
  taskIds: string[];
};

/**
 * Describes the message lvdr.v2.cos.WorkBatchSplitGroup.
 * Use `create(WorkBatchSplitGroupSchema)` to create a new message.
 */
export const WorkBatchSplitGroupSchema: GenMessage<WorkBatchSplitGroup> = /*@__PURE__*/
  messageDesc(file_cos_workbatch, 5);

/**
 * Exactly one action per request: (move_out and/or clear_item) | split | undo | accept | dismiss.
 *
 * @generated from message lvdr.v2.cos.UpdateWorkBatchOverridesRequest
 */
export type UpdateWorkBatchOverridesRequest = Message<"lvdr.v2.cos.UpdateWorkBatchOverridesRequest"> & {
  /**
   * @generated from field: string workspace_id = 1;
   */
  workspaceId: string;

  /**
   * @generated from field: repeated string move_out = 2;
   */
  moveOut: string[];

  /**
   * @generated from field: repeated string clear_item = 3;
   */
  clearItem: string[];

  /**
   * @generated from field: lvdr.v2.cos.WorkBatchSplit split = 4;
   */
  split?: WorkBatchSplit | undefined;

  /**
   * @generated from field: bool undo = 5;
   */
  undo: boolean;

  /**
   * @generated from field: string accept_proposal_id = 6;
   */
  acceptProposalId: string;

  /**
   * "" keeps the proposal's label (proto3 cannot send "clear")
   *
   * @generated from field: string accept_label = 7;
   */
  acceptLabel: string;

  /**
   * @generated from field: string dismiss_proposal_id = 8;
   */
  dismissProposalId: string;
};

/**
 * Describes the message lvdr.v2.cos.UpdateWorkBatchOverridesRequest.
 * Use `create(UpdateWorkBatchOverridesRequestSchema)` to create a new message.
 */
export const UpdateWorkBatchOverridesRequestSchema: GenMessage<UpdateWorkBatchOverridesRequest> = /*@__PURE__*/
  messageDesc(file_cos_workbatch, 6);

/**
 * @generated from message lvdr.v2.cos.UpdateWorkBatchOverridesResponse
 */
export type UpdateWorkBatchOverridesResponse = Message<"lvdr.v2.cos.UpdateWorkBatchOverridesResponse"> & {
  /**
   * @generated from field: lvdr.v2.cos.ListWorkBatchesResponse state = 1;
   */
  state?: ListWorkBatchesResponse | undefined;
};

/**
 * Describes the message lvdr.v2.cos.UpdateWorkBatchOverridesResponse.
 * Use `create(UpdateWorkBatchOverridesResponseSchema)` to create a new message.
 */
export const UpdateWorkBatchOverridesResponseSchema: GenMessage<UpdateWorkBatchOverridesResponse> = /*@__PURE__*/
  messageDesc(file_cos_workbatch, 7);

